export function getEmployees() {
  return async (dispatch, _getState, {api}) => {
    const {data} = await api.getEmployees();
    dispatch({type: 'employees/load', employees: data.employees});
    return data.employees;
  }
}

export function saveEmployee(employee) {
  return async (dispatch, _getState, {api}) => {
    const apiEndpoint = employee.uuid ? api.updateEmployee : api.createEmployee;
    const {data} = await apiEndpoint(employee);
    dispatch({type: 'employee/load', employee: data.employee});
    return data.employee;
  }
}
